/* AbNoor — collection: family chips, colour sort, count. */
(function () {
  'use strict';

  /* Hue-first ordering so warm stones sit together and neutrals fall to the end. */
  function sortKey(hex) {
    var m = String(hex || '').trim().replace('#', '');
    if (m.length === 3) m = m[0] + m[0] + m[1] + m[1] + m[2] + m[2];
    if (!/^[0-9a-f]{6}$/i.test(m)) return [3, 0, 0];
    var r = parseInt(m.slice(0, 2), 16) / 255;
    var g = parseInt(m.slice(2, 4), 16) / 255;
    var b = parseInt(m.slice(4, 6), 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var l = (max + min) / 2;
    var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
    var h = 0;
    if (d !== 0) {
      if (max === r) h = ((g - b) / d) % 6;
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    /* near-greys and near-blacks last, grouped by lightness */
    if (s < 0.14) return [2, l, 0];
    return [1, h, -l];
  }

  function cmp(a, b) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return 0;
  }

  function init(root) {
    if (!root || root.dataset.abnoorReady === '1') return;
    root.dataset.abnoorReady = '1';

    var grid = root.querySelector('[data-coll-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-coll-card]'));
    var closing = grid.querySelector('[data-coll-closing]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-coll-family]'));
    var sortBtn = root.querySelector('[data-coll-sort]');
    var countEl = root.querySelector('[data-coll-count]');

    var docOrder = cards.slice();
    var family = 'all';
    var byColour = false;

    /* Pin the bar directly under whatever is covering the top of the screen.
       Rather than trusting a measured header height (which on this theme
       included ~100px of wrapper), look at what is actually painted at the
       top edge and use the bottom of the nearest fixed/sticky thing there. */
    var bar = root.querySelector('.abnoor-coll__bar');
    if (bar && document.elementsFromPoint) {
      var pinnedOf = function (el) {
        for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          var p = getComputedStyle(n).position;
          if (p === 'fixed' || p === 'sticky') return n;
        }
        return null;
      };
      var coverBottom = function () {
        /* Our own header: use the visible row (logo · nav · cart), not the
           outer box — at desktop widths the outer box runs ~100px taller
           than what is painted, which is exactly the gap that showed. */
        var row = document.querySelector('.abnoor-header__bar');
        var head = row && row.closest('.abnoor-header');
        if (row && head) {
          var hr = head.getBoundingClientRect();
          var rr = row.getBoundingClientRect();
          var pos = getComputedStyle(head).position;
          if ((pos === 'fixed' || pos === 'sticky') && hr.top <= 2 && rr.bottom > 0) {
            return Math.max(0, Math.round(rr.bottom) + 1);   // +1 for the rule under the row
          }
          if (rr.bottom > 0 && hr.top <= 2) return Math.round(rr.bottom) + 1;
          return 0;
        }
        // Any other theme header: nearest fixed/sticky thing at the top edge.
        var xs = [window.innerWidth * 0.5, window.innerWidth * 0.2, window.innerWidth * 0.8];
        var best = 0;
        xs.forEach(function (x) {
          var stack = document.elementsFromPoint(x, 3);
          for (var i = 0; i < stack.length; i++) {
            var el = stack[i];
            if (bar.contains(el)) continue;
            var pin = pinnedOf(el);
            if (!pin || pin.contains(bar)) continue;
            var r = pin.getBoundingClientRect();
            if (r.top <= 2 && r.bottom > best) best = r.bottom;
            break;
          }
        });
        return Math.round(best);
      };
      var ticking = false;
      var place = function () {
        ticking = false;
        bar.style.setProperty('top', coverBottom() + 'px', 'important');
      };
      var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } };
      place();
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      var settleT = null;
      window.addEventListener('scroll', function () {
        clearTimeout(settleT);
        settleT = setTimeout(place, 300);
      }, { passive: true });
      setTimeout(place, 500);
    }

    var lede = root.querySelector('[data-coll-lede]');
    var lines = {};
    root.querySelectorAll('[data-coll-line]').forEach(function (s) {
      lines[s.getAttribute('data-coll-line')] = s.textContent;
    });

    function paint() {
      var shown = 0;
      cards.forEach(function (c) {
        var on = family === 'all' || (c.dataset.family || '') === family;
        c.hidden = !on;
        if (on) shown++;
      });

      var order = byColour
        ? cards.slice().sort(function (a, b) { return cmp(sortKey(a.dataset.hex), sortKey(b.dataset.hex)); })
        : docOrder;
      order.forEach(function (c) { grid.appendChild(c); });
      if (closing) {
        closing.hidden = family !== 'all';
        grid.appendChild(closing);
      }

      chips.forEach(function (b) { b.classList.toggle('is-on', b.dataset.collFamily === family); });
      if (lede) {
        var line = lines[family] || lines.all;
        if (line && lede.textContent !== line) lede.textContent = line;
      }
      if (sortBtn) {
        sortBtn.classList.toggle('is-on', byColour);
        sortBtn.textContent = byColour ? 'Sorted by colour' : 'Sort by colour';
      }
      if (countEl) countEl.textContent = shown === 1 ? '1 piece' : shown + ' pieces';
    }

    chips.forEach(function (b) {
      b.addEventListener('click', function () { family = b.dataset.collFamily; paint(); });
    });
    if (sortBtn) sortBtn.addEventListener('click', function () { byColour = !byColour; paint(); });

    /* Card photo carousel — arrows step through every product image. */
    root.querySelectorAll('[data-coll-stage]').forEach(function (stage) {
      var shots = stage.querySelectorAll('[data-coll-shot]');
      var pips = stage.querySelectorAll('[data-coll-pip]');
      if (shots.length < 2) return;
      var at = 0;
      function show(n) {
        at = (n + shots.length) % shots.length;
        shots.forEach(function (im, i) { im.classList.toggle('is-on', i === at); });
        pips.forEach(function (p, i) { p.classList.toggle('is-on', i === at); });
      }
      var prev = stage.querySelector('[data-coll-prev]');
      var next = stage.querySelector('[data-coll-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(at - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); show(at + 1); });
    });

    /* drop the edge fade once the strip is scrolled to the end */
    var strip = root.querySelector('.abnoor-coll__chips');
    if (strip) {
      var edge = function () {
        var done = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
        strip.classList.toggle('is-end', done || strip.scrollWidth <= strip.clientWidth + 2);
      };
      strip.addEventListener('scroll', edge, { passive: true });
      window.addEventListener('resize', edge);
      edge();
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-abnoor-coll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
